<aside class="sidebar">
  <header class="sidebar-brand">
    @if (logoUrl(); as logo) {
      <img [src]="logo" alt="Logo Empresa" />
    }
    <p class="sidebar-brand-subtitle">Oficina Virtual</p>
  </header>

  <nav class="sidebar-nav" aria-label="Menú principal">
    <div class="sidebar-section">
      <p class="sidebar-section-title">Navegación</p>
      <ul class="sidebar-menu">
        @for (item of menuItems(); track item.label) {
          @if (item.label === 'Inicio' || item.label === 'Mis propiedades') {
            <li>
              @if (item.submenu && item.submenu.length > 0) {
                <a
                  (click)="toggleSubmenu(item)"
                  class="menu-link"
                  [class.active-parent]="item.open"
                >
                  <i-lucide [name]="item.icon" class="icon-sub"></i-lucide>
                  <span>{{ item.label }}</span>
                  @if (item.showAttention) {
                    <span
                      class="menu-attention-dot"
                      [class.menu-attention-dot--orange]="item.attentionTone === 'orange'"
                      [attr.aria-label]="
                        item.attentionAriaLabel ?? 'ReciboVerde pendiente de activar'
                      "
                    ></span>
                  }
                </a>

                @if (item.open) {
                  <ul class="submenu">
                    @for (sub of item.submenu; track sub.label) {
                      <li>
                        @if (sub.external) {
                          <a [href]="sub.route" target="_blank" rel="noopener noreferrer">
                            @if (sub.imgIcon) {
                              <img [src]="sub.imgIcon" alt="" class="submenu-img-icon" />
                            }
                            <span>{{ sub.label }}</span>
                            @if (sub.showAttention) {
                              <span
                                class="menu-attention-dot"
                                [class.menu-attention-dot--orange]="sub.attentionTone === 'orange'"
                                [attr.aria-label]="
                                  sub.attentionAriaLabel ?? 'ReciboVerde pendiente de activar'
                                "
                              ></span>
                            }
                          </a>
                        } @else {
                          <a [routerLink]="sub.route" routerLinkActive="active-link">
                            @if (sub.imgIcon) {
                              <img [src]="sub.imgIcon" alt="" class="submenu-img-icon" />
                            }
                            <span>{{ sub.label }}</span>
                            @if (sub.showAttention) {
                              <span
                                class="menu-attention-dot"
                                [class.menu-attention-dot--orange]="sub.attentionTone === 'orange'"
                                [attr.aria-label]="
                                  sub.attentionAriaLabel ?? 'ReciboVerde pendiente de activar'
                                "
                              ></span>
                            }
                          </a>
                        }
                      </li>
                    }
                  </ul>
                }
              } @else {
                <a [routerLink]="item.route" routerLinkActive="active-link" class="menu-link">
                  <i-lucide [name]="item.icon" class="icon"></i-lucide>
                  <span>{{ item.label }}</span>
                </a>
              }
            </li>
          }
        }
      </ul>
    </div>

    @if (showConsumptionSection()) {
      <div class="sidebar-section">
        <p class="sidebar-section-title">{{ consumptionSectionTitle() }}</p>
        <ul class="sidebar-menu">
          @for (item of menuItems(); track item.label) {
            @if (
              item.label === 'Mis liquidaciones' ||
              item.label === 'Mis consumos' ||
              item.label === 'Enviar lectura' ||
              item.label === 'Simula tu liquidación'
            ) {
              <li>
                @if (item.submenu && item.submenu.length > 0) {
                  <a
                    (click)="toggleSubmenu(item)"
                    class="menu-link"
                    [class.active-parent]="item.open"
                  >
                    <i-lucide [name]="item.icon" class="icon-sub"></i-lucide>
                    <span>{{ item.label }}</span>
                    @if (item.showAttention) {
                      <span
                        class="menu-attention-dot"
                        [class.menu-attention-dot--orange]="item.attentionTone === 'orange'"
                        [attr.aria-label]="
                          item.attentionAriaLabel ?? 'ReciboVerde pendiente de activar'
                        "
                      ></span>
                    }
                  </a>

                  @if (item.open) {
                    <ul class="submenu">
                      @for (sub of item.submenu; track sub.label) {
                        <li>
                          @if (sub.external) {
                            <a [href]="sub.route" target="_blank" rel="noopener noreferrer">
                              @if (sub.imgIcon) {
                                <img [src]="sub.imgIcon" alt="" class="submenu-img-icon" />
                              }
                              <span>{{ sub.label }}</span>
                              @if (sub.showAttention) {
                                <span
                                  class="menu-attention-dot"
                                  aria-label="ReciboVerde pendiente de activar"
                                ></span>
                              }
                            </a>
                          } @else {
                            <a [routerLink]="sub.route" routerLinkActive="active-link">
                              @if (sub.imgIcon) {
                                <img [src]="sub.imgIcon" alt="" class="submenu-img-icon" />
                              }
                              <span>{{ sub.label }}</span>
                              @if (sub.showAttention) {
                                <span
                                  class="menu-attention-dot"
                                  aria-label="ReciboVerde pendiente de activar"
                                ></span>
                              }
                            </a>
                          }
                        </li>
                      }
                    </ul>
                  }
                } @else {
                  <a [routerLink]="item.route" routerLinkActive="active-link" class="menu-link">
                    <i-lucide [name]="item.icon" class="icon"></i-lucide>
                    <span>{{ item.label }}</span>
                  </a>
                }
              </li>
            }
          }
        </ul>
      </div>
    }

    @if (showMonitoringSection()) {
      <div class="sidebar-section">
        <p class="sidebar-section-title">{{ monitoringSectionTitle }}</p>
        <ul class="sidebar-menu">
          @for (item of menuItems(); track item.label) {
            @if (item.label === 'Lecturas diarias' || item.label === 'Alarmas') {
              <li>
                <a [routerLink]="item.route" routerLinkActive="active-link" class="menu-link">
                  <i-lucide [name]="item.icon" class="icon"></i-lucide>
                  <span>{{ item.label }}</span>
                </a>
              </li>
            }
          }
        </ul>
      </div>
    }

    <div class="sidebar-section">
      <p class="sidebar-section-title">Soporte</p>
      <ul class="sidebar-menu">
        @for (item of menuItems(); track item.label) {
          @if (item.label === 'Enviar consulta' || item.label === 'Ajustes') {
            <li>
              @if (item.submenu && item.submenu.length > 0) {
                <a
                  (click)="toggleSubmenu(item)"
                  class="menu-link"
                  [class.active-parent]="item.open"
                >
                  <i-lucide [name]="item.icon" class="icon-sub"></i-lucide>
                  <span>{{ item.label }}</span>
                  @if (item.showAttention) {
                    <span
                      class="menu-attention-dot"
                      [class.menu-attention-dot--orange]="item.attentionTone === 'orange'"
                      [attr.aria-label]="
                        item.attentionAriaLabel ?? 'ReciboVerde pendiente de activar'
                      "
                    ></span>
                  }
                </a>

                @if (item.open) {
                  <ul class="submenu">
                    @for (sub of item.submenu; track sub.label) {
                      <li>
                        @if (sub.external) {
                          <a [href]="sub.route" target="_blank" rel="noopener noreferrer">
                            @if (sub.imgIcon) {
                              <img [src]="sub.imgIcon" alt="" class="submenu-img-icon" />
                            }
                            <span>{{ sub.label }}</span>
                            @if (sub.showAttention) {
                              <span
                                class="menu-attention-dot"
                                [class.menu-attention-dot--orange]="sub.attentionTone === 'orange'"
                                [attr.aria-label]="
                                  sub.attentionAriaLabel ?? 'ReciboVerde pendiente de activar'
                                "
                              ></span>
                            }
                          </a>
                        } @else {
                          <a [routerLink]="sub.route" routerLinkActive="active-link">
                            @if (sub.imgIcon) {
                              <img [src]="sub.imgIcon" alt="" class="submenu-img-icon" />
                            }
                            <span>{{ sub.label }}</span>
                            @if (sub.showAttention) {
                              <span
                                class="menu-attention-dot"
                                [class.menu-attention-dot--orange]="sub.attentionTone === 'orange'"
                                [attr.aria-label]="
                                  sub.attentionAriaLabel ?? 'ReciboVerde pendiente de activar'
                                "
                              ></span>
                            }
                          </a>
                        }
                      </li>
                    }
                  </ul>
                }
              } @else {
                <a [routerLink]="item.route" routerLinkActive="active-link" class="menu-link">
                  <i-lucide [name]="item.icon" class="icon"></i-lucide>
                  <span>{{ item.label }}</span>
                </a>
              }
            </li>
          }
        }
      </ul>
    </div>
  </nav>

  <div class="sidebar-footer">
    @if (buildInfo.showEnvironmentBadge()) {
      <p-message severity="info" styleClass="app-environment-meta sidebar-environment-meta">
        <span class="app-environment-meta__badge">{{ buildInfo.environmentLabel() }}</span>
        <span class="app-environment-meta__version">{{ buildInfo.versionLabel() }}</span>
      </p-message>
    }
    <button type="button" (click)="logout()">
      <i-lucide name="log-out" class="icon"></i-lucide>
      <span>Cerrar sesión</span>
    </button>
    @if (isGGM()) {
      <a class="previous-office" data-testid="ov-previous-office" [href]="previousOfficeUrl">
        Versión anterior
      </a>
    }
  </div>
</aside>
